import { Badge } from '@mantine/core'
import { NO_CHANGE } from '../format'
import type { Measure } from '../hooks'
import { STATUS_LABELS } from '../labels'

const COLORS = { improving: 'teal', stable: 'gray', declining: 'orange' } as const

/** A measure's time-to-resolve status; blank ("—") when either period resolved nothing. */
export function StatusBadge({ status }: { status: Measure['status'] }) {
  if (status === null) return <span className="text-gray-500">{NO_CHANGE}</span>
  return (
    <Badge variant="light" color={COLORS[status]} size="sm">
      {STATUS_LABELS[status]}
    </Badge>
  )
}
